import { useRef as f } from "react";
import { forwardRefWithAs as n, render as p } from "../../utils/render.js";
import { useFocusTrap as T, Features as r } from "../../hooks/use-focus-trap.js";
import { useServerHandoffComplete as m } from "../../hooks/use-server-handoff-complete.js";
import { useSyncRefs as i } from "../../hooks/use-sync-refs.js";
let c = "div",
  O = n(function (t, o) {
    let e = f(null),
      l = i(e, o),
      {
        initialFocus: s,
        ...u
      } = t,
      a = m();
    return T(e, a ? r.All : r.None, {
      initialFocus: s
    }), p({
      ourProps: {
        ref: l
      },
      theirProps: u,
      defaultTag: c,
      name: "FocusTrap"
    });
  });
export { O as FocusTrap };